import { Mot } from './mots/mot';
import { TrafficNode } from './trafficNodes/trafficNode';
import { MetaData } from './MetaData';
/**
 * class {Line}
 * should be used to display line related information
 */
export class Line extends MetaData {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param direction
     * @param name
     * @param lineNumber
     * @param mot
     * @param network
     * @param operator
     */
    constructor(id, direction, name, lineNumber, mot, lineNumberId, network, operator, accessibilityInfo, metaData) {
        super(metaData);
        this._id = id;
        this._direction = direction;
        this._name = name;
        this._lineNumber = lineNumber;
        this._mot = mot;
        this._lineNumberId = lineNumberId;
        this._network = network;
        this._operator = operator;
        this._accessibilityInfo = accessibilityInfo;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Line}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.direction = values.direction ? TrafficNode.factory(values.direction) : TrafficNode.factory({});
        sanitizedValues.name = values.name ? values.name : '';
        sanitizedValues.lineNumber = values.lineNumber ? values.lineNumber : '';
        sanitizedValues.mot = values.mot ? Mot.factory(values.mot) : Mot.factory({});
        sanitizedValues.lineNumberId = values.lineNumberId ? values.lineNumberId : '';
        sanitizedValues.network = values.network ? values.network : '';
        sanitizedValues.operator = values.operator ? values.operator : '';
        sanitizedValues.accessibilityInfo = values.accessibilityInfo !== undefined ? values.accessibilityInfo : [];
        sanitizedValues.metaData = values.metaData !== undefined ? values.metaData : {};
        return new Line(sanitizedValues.id, sanitizedValues.direction, sanitizedValues.name, sanitizedValues.lineNumber, sanitizedValues.mot, sanitizedValues.lineNumberId, sanitizedValues.network, sanitizedValues.operator, sanitizedValues.accessibilityInfo, sanitizedValues.metaData);
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets the direction of this line
     * @returns {TrafficNode}
     */
    get direction() {
        return this._direction;
    }
    /**
     * sets the direction of this line
     * @param direction
     */
    set direction(direction) {
        this._direction = direction;
    }
    /**
     * gets the line name
     * @returns {string}
     */
    get name() {
        return this._name;
    }
    /**
     * sets the line name
     * @param name
     */
    set name(name) {
        this._name = name;
    }
    /**
     * gets the line lineNumber
     * @returns {string}
     */
    get lineNumber() {
        return this._lineNumber;
    }
    /**
     * sets the line lineNumber
     * @param lineNumber
     */
    set lineNumber(lineNumber) {
        this._lineNumber = lineNumber;
    }
    /**
     * gets the line mot
     * @returns Mot
     */
    get mot() {
        return this._mot;
    }
    /**
     * sets the line mot
     * @param mot
     */
    set mot(mot) {
        this._mot = mot;
    }
    /**
     * gets the diva number
     * @returns diva number
     */
    get lineNumberId() {
        return this._lineNumberId;
    }
    /**
     * sets the diva number
     * @param diva number
     */
    set lineNumberId(lineNumberId) {
        this._lineNumberId = lineNumberId;
    }
    /**
     * gets the network name
     * @returns network name
     */
    get network() {
        return this._network;
    }
    /**
     * sets the network name
     * @param network network name
     */
    set network(network) {
        this._network = network;
    }
    /**
     * gets the operator name
     * @returns operator name
     */
    get operator() {
        return this._operator;
    }
    /**
     * sets the operator name
     * @param operator operator name
     */
    set operator(operator) {
        this._operator = operator;
    }
    /**
     * gets the accessibility info array
     * @returns accessibility info
     */
    get accessibilityInfo() {
        return this._accessibilityInfo;
    }
    /**
     * sets the accessibility info array
     * @param accessibilityInfo an array of accessibility info strings
     */
    set accessibilityInfo(accessibilityInfo) {
        this._accessibilityInfo = accessibilityInfo;
    }
}
//# sourceMappingURL=line.js.map